import { initializeApp, getApps, getApp, deleteApp } from "firebase/app";
import { logEvent, getAnalytics, setUserId } from "firebase/analytics";
import { sessionModel } from "entities/session";
import {
  getMessaging,
  getToken,
  isSupported,
  Messaging,
} from "firebase/messaging";
import {
  ActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from "@capacitor/push-notifications";
import { Capacitor } from "@capacitor/core";
import { getFCMRegistration } from "serviceWorker";

const devMode = process.env.REACT_APP_DEV_MODE === "true";

const firebaseConfig = devMode
  ? {
      apiKey: "AIzaSyA8QE0NnKdMfH_h3P9uOlSwVy4W_lx0I7s",
      authDomain: "sircap-dev.firebaseapp.com",
      projectId: "sircap-dev",
      storageBucket: "sircap-dev.appspot.com",
      messagingSenderId: "731140448324",
      appId: "1:731140448324:web:87ccdaff8316814c465c11",
      measurementId: "G-ENWSVW3FDJ",
    }
  : {
      apiKey: "AIzaSyC8TPKTn_yHlUZ6l8rjF1UVveGENasCANM",
      authDomain: "sirius-app-5c5a2.firebaseapp.com",
      projectId: "sirius-app-5c5a2",
      storageBucket: "sirius-app-5c5a2.firebasestorage.app",
      messagingSenderId: "980015493238",
      appId: "1:980015493238:web:f6a264f8d3cff097fdef57",
      measurementId: "G-4JDGZZ1538",
    };

// console.log(
//   `Initialize firebase app!\nFirebase config: ${JSON.stringify(
//     firebaseConfig,
//     null,
//     2
//   )}`
// );

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

const analytics = getAnalytics(app);

const firebaseLogEvent = (name: string, params?: any) => {
  const analytics = getAnalytics();

  const user_id =
    sessionModel.sessionStore.getState().user?.identificator || undefined;

  if (user_id) {
    // set for ga4
    setUserId(analytics, user_id);
  }

  // logEvent(analytics, name, params); //ga4

  if ((window as any).dataLayer) {
    (window as any).dataLayer.push({
      event: name,
      user_id: user_id,
      ...params,
    }); // gtm

    // console.log((window as any).dataLayer.at(-1));
  }

  // * checker log
  //   console.log(`📡 Event sent: ${user_id} ${name}`, params);
};

const messaging = (async () => {
  try {
    const isSupportedBrowser = await isSupported();
    if (isSupportedBrowser) {
      return getMessaging(app);
    }
    return null;
  } catch (err) {
    return null;
  }
})();

// if (Capacitor.getPlatform() === "ios") {
//   PushNotifications.addListener("registration", (token: Token) => {
//     sessionModel.sessionStore.getState().enableNotifications({
//       notification_token: token.value,
//       platform: Capacitor.getPlatform(),
//     });
//   });
// } else {
//   messaging.then(async (messagingService) => {
//     if (!messagingService) return;
//     (messagingService as any).onTokenRefresh?.(async () => {
//       try {
//         const newToken = await getToken(messagingService as Messaging, {
//           serviceWorkerRegistration: await getFCMRegistration(),
//         });
//         sessionModel.sessionStore.getState().enableNotifications({
//           notification_token: newToken,
//           platform: Capacitor.getPlatform(),
//         });
//       } catch (err) {
//         console.log("An error occurred while retrieving token. ", err);
//       }
//     });
//   });
// }

const requestForToken = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const platform = Capacitor.getPlatform();
      if (platform === "ios" || platform === "android") {
        const result = await PushNotifications.requestPermissions();
        if (result.receive === "granted") {
          // Register with Apple / Google to receive push via APNS/FCM
          await PushNotifications.register();

          // On success, we should be able to receive notifications
          PushNotifications.addListener("registration", (token: Token) => {
            console.log("Push registration success, token: " + token.value);
            resolve(token.value);
          });

          // Some issue with our setup and push will not work
          PushNotifications.addListener("registrationError", (error: any) => {
            // alert("Error on registration: " + JSON.stringify(error));
            reject(JSON.stringify(error));
          });

          // Show us the notification payload if the app is open on our device
          PushNotifications.addListener(
            "pushNotificationReceived",
            (notification: PushNotificationSchema) => {
              console.log("Push received: " + JSON.stringify(notification));
            }
          );

          // Method called when tapping on a notification
          PushNotifications.addListener(
            "pushNotificationActionPerformed",
            (notification: ActionPerformed) => {
              console.log(
                "Push action performed: " + JSON.stringify(notification)
              );
            }
          );
        } else {
          reject(null);
        }
      } else {
        const messagingService = await messaging;
        if (!messagingService) resolve(null);
        const currentToken = await getToken(messagingService as Messaging, {
          serviceWorkerRegistration: await getFCMRegistration(),
        });
        if (currentToken) {
          console.log("Current token for client: ", currentToken);
          resolve(currentToken);
        } else {
          console.log(
            "No registration token available. Request permission to generate one."
          );
          reject(null);
        }
      }
    } catch (err) {
      console.log("An error occurred while retrieving token. ", err);
      reject(err);
    }
  });
};

export { analytics, firebaseLogEvent, messaging, requestForToken };
